import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data: null,
  isinitConfigExist: null,
  isConfigExist: null
};

export const getShopifyAppConfig = createAsyncThunk(
  "getShopifyAppConfig",
  async (storeURL) => {
    try {
      const response = await fetch(`/api/getShopifyAppConfig/${storeURL}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch config");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getShopifyAppConfig",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getShopifyAppConfig.pending, (state) => {
        state.status = "INPROGRESS";
        state.message = null;
      })
      .addCase(getShopifyAppConfig.fulfilled, (state, action) => {
        state.status = "Shopify app config Completed";
        const initConfig = action.payload?.data.data;
        state.isinitConfigExist = !!initConfig?.initConfigurationData;
        state.data = initConfig?.initConfigurationData;
        // state.data = initConfig?.
        state.isConfigExist = !!initConfig?.configurationData;

      })
      .addCase(getShopifyAppConfig.rejected, (state, action) => {
        state.status = "Shopify app config error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
